export default "__VITE_ASSET__6e50a62a__$_?component__"